const url = process.env.REACT_APP_API_IMAGE_URL
export const imageUrl = {
  carousel: url + '/carousel/',
  gallery: url + '/gallery/',
  testimony: url + '/testimony/',
  blog: url + '/blog/',
  header: url + '/header/',
  team: url + '/team/',
  company: url + '/company/',
  about: url + '/about/',
};